var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4007_404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 0C9.40242 0 0.000488281 9.40221 0.000488281 20.9998C0.000488281 32.5971 9.40242 42 21 42C32.5976 42 42.0002 32.5971 42.0002 20.9998C42.0002 9.40193 32.5976 0 21 0ZM21.064 30.9071V30.9068H11.9656C11.9656 24.3469 17.7269 24.3485 19.0054 22.6332L19.1517 21.851C17.3555 20.9407 16.0875 18.746 16.0875 16.1793C16.0875 12.7977 18.2872 10.0559 21 10.0559C23.7128 10.0559 25.9125 12.7977 25.9125 16.1793C25.9125 18.7242 24.6671 20.9051 22.8948 21.8299L23.0614 22.7187C24.4641 24.3509 30.0337 24.4573 30.0337 30.9071H21.064Z",
    fill: "#1ADCE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4007_404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.4ffcd083b67ddc752d162b4804a9d9b3.svg";
export { ForwardRef as ReactComponent };